import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const email = localStorage.getItem("gabryx_email");
    const token = localStorage.getItem("gabryx_token");
    return email && token ? { email } : null;
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("gabryx_token", data.token);
      localStorage.setItem("gabryx_email", data.email);
      setUser({ email: data.email });
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e?.response?.data?.detail || "Connexion impossible" };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("gabryx_token");
    localStorage.removeItem("gabryx_email");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
